import React, { useEffect } from 'react';

export default function PrivacyPage() {
  useEffect(() => {
    window.location.href = 'https://www.iubenda.com/privacy-policy/43603356';
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p>Reindirizzamento alla Privacy Policy...</p>
    </div>
  );
}
